import Hero from "@/components/Hero";
import AnnouncementBar from "@/components/AnnouncementBar";
import Countdown from "@/components/Countdown";
import Marquee from "@/components/Marquee";
import Stats from "@/components/Stats";
import About from "@/components/About";
import Forums from "@/components/Forums";
import CommitteesPreview from "@/components/CommitteesPreview";
import Secretariat from "@/components/Secretariat";
import SchedulePreview from "@/components/SchedulePreview";
import Brochure from "@/components/Brochure";
import Gallery from "@/components/Gallery";
import FinalCTA from "@/components/FinalCTA";

export default function Home() {
    return (
        <>
            <Hero />
            <AnnouncementBar />
            <Countdown />
            <Marquee />
            <Stats />
            <About />
            <Forums />
            <CommitteesPreview />
            <Secretariat />
            <SchedulePreview />
            <Brochure />
            <Gallery />
            <FinalCTA />
        </>
    );
}
